import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Eye, CalendarDays, MapPin, User } from "lucide-react";
import { api, mediaUrl, formatWIT, CONTENT_TYPE_LABELS } from "@/lib/appApi";
import { StatusBadge } from "@/lib/adminConst";

export default function ArticlePreview() {
  const { id } = useParams();
  const [art, setArt] = useState(null);
  const [units, setUnits] = useState({});

  useEffect(() => {
    api.get(`/articles/${id}/preview`).then((r) => setArt(r.data)).catch(() => {});
    api.get("/public/units").then((r) => setUnits(Object.fromEntries(r.data.map((u) => [u.slug, u]))));
  }, [id]);

  if (!art) return <p className="text-gray-500">Memuat…</p>;
  const unit = units[art.responsible_unit];

  return (
    <div className="max-w-3xl mx-auto">
      <div className="flex items-center justify-between mb-4">
        <Link to={`/admin/konten/${id}`} className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-dlh-green"><ArrowLeft className="h-4 w-4" /> Kembali ke Editor</Link>
        <StatusBadge status={art.status} />
      </div>
      <div className="bg-dlh-orange/10 border border-dlh-orange/30 rounded-lg p-3 mb-6 text-sm text-dlh-orangeDark flex items-center gap-2">
        <Eye className="h-4 w-4" /> Pratinjau — hanya terlihat oleh pengguna berwenang. Belum tentu terbit.
      </div>

      <span className="bg-dlh-orange text-white text-xs font-bold px-3 py-1 rounded uppercase">{CONTENT_TYPE_LABELS[art.content_type]}</span>
      <h1 className="font-serif text-3xl font-extrabold text-dlh-green mt-3 leading-tight break-words">{art.title}</h1>
      <p className="mt-3 text-lg text-gray-600">{art.summary}</p>
      <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-sm text-gray-500 border-y py-3">
        {art.author_name && <span className="flex items-center gap-1.5"><User className="h-4 w-4" />{art.author_name}</span>}
        <span className="flex items-center gap-1.5"><CalendarDays className="h-4 w-4" />{unit?.short_name}</span>
        {art.event_location && <span className="flex items-center gap-1.5"><MapPin className="h-4 w-4" />{art.event_location}</span>}
      </div>
      {art.featured_media_url && <img src={mediaUrl(art.featured_media_url)} alt="" className="w-full rounded-lg mt-6 object-cover" />}
      <div className="rte-content mt-6" dangerouslySetInnerHTML={{ __html: art.body_html }} />
    </div>
  );
}
